import { Component, OnInit } from '@angular/core';
import { Beneficirani } from './beneficirani';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-beneficirani',
  templateUrl: './beneficirani.component.html'
})
export class BeneficiraniComponent
 extends BaseModalContainer<Beneficirani> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Beneficirani>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
